

document.addEventListener('DOMContentLoaded', () => {

    const productTitleLinks = document.querySelectorAll('.card__heading a.full-unstyled-link');

    if (productTitleLinks.length === 0) {
        console.warn('BoldSecondWord: No product title links found using the selector.');
        return;
    }

    productTitleLinks.forEach(link => {
        const originalText = link.textContent.trim();

        const words = originalText.split(/\s+/);


        if (words.length >= 2) {

            const secondWord = words[1];

            let newText = originalText.replace(

                new RegExp('\\b' + secondWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '\\b'),
                `<b>${secondWord}</b>`
            );

            link.innerHTML = newText;
        }
    });

    console.log(`BoldSecondWord: Successfully processed ${productTitleLinks.length} product titles.`);
});